import { SITE_ORIGIN } from './siteConfig';
import { META_HOME } from './seoMeta';

export const DEFAULT_PAGE_TITLE = META_HOME.title;

export const DEFAULT_META_DESCRIPTION = META_HOME.description;

export const META_DESC_MAX = 140;

export function clampMetaDescription(raw, max = META_DESC_MAX) {
  if (!raw || typeof raw !== 'string') return '';
  const t = raw.trim();
  if (t.length <= max) return t;
  return `${t.slice(0, max - 1).trimEnd()}…`;
}

export function setCanonical(href) {
  const el = document.querySelector('link[rel="canonical"]');
  if (el) el.setAttribute('href', href || `${SITE_ORIGIN}/`);
}

export function getMetaDescriptionEl() {
  return document.querySelector('meta[name="description"]');
}
